import Drawer from './Drawer';
import Provider, { useUploadingDrawer, STATUS_COMPLETED, STATUS_FAILED } from './Provider';

export default Drawer;
export { Provider, useUploadingDrawer, STATUS_COMPLETED, STATUS_FAILED };
